<!-- eslint-disable vue/no-v-html -->
<template>
	<section
		v-if="cfg"
		class="main-container py-5">
		<b-container>
			<h3
				class="mb-4"
				v-html="title" />
			<div class="row gx-0">
				<div
					v-for="(col, idx) in columns"
					:key="'col-'+idx"
					class="col-md-4">
					<ul>
						<li
							v-for="(item, i) in col"
							:key="'item-'+idx+'-'+i">
							{{ item }}
						</li>
					</ul>
				</div>
			</div>
		</b-container>
	</section>
</template>

<script>
import { JnsLandingPages } from '@/translations';
import { PRODUCT_PAGES } from '@/settings/JnsLandingPages';
import Page from '@/views/JnsLandingPages/mixins/Page';
import Storage from '@/views/JnsLandingPages/mixins/Storage';
import Replacements from '@/views/JnsLandingPages/mixins/Replacements';

export default {
	name: 'IngredientsThreeCol',
	messages: [JnsLandingPages],
	mixins: [Page, Storage, Replacements],
	computed: {
		cfg() {
			return PRODUCT_PAGES[this.pageName]?.ingredientsThreeCol || null;
		},
		title() {
			return this.applyReplacements(this.translate(this.cfg?.title || ''));
		},
		translateList() {
			return (list = []) => list
				.map((k) => this.applyReplacements(this.translate(k)))
				.filter(Boolean);
		},
		columns() {
			const cols = this.cfg?.columns || [];
			return cols.map((col) => this.translateList(col));
		},
	},
};
</script>

<style scoped>
.main-container {
	background: linear-gradient(
		to bottom,
		#ffffff 0%,
		#f9f9f9 100%
	);
}

.main-container ul {
	list-style: disc;
	padding-left: 1.25rem;
	margin: 0;
}

.main-container li {
	list-style: disc;
}

h3 {
	font-weight: bolder;

}

@media (max-width: 767px) {
	.main-container {
		text-align: center;
	}
	.main-container ul {
		list-style: none;
		padding-left: 0;
	}
}
</style>
